const formatNumber = (
  number: number,
  options: Intl.NumberFormatOptions = { maximumFractionDigits: 2 },
  locale = 'en-US'
): string => Intl.NumberFormat(locale, options).format(number);

export default formatNumber;
